import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { MpsUserService } from '../../../mps/services/mps-user.service';
import { User } from '../_models/user';
import { UserService } from '../_services/user.service';


@Injectable({
  providedIn: 'root'
})
export class IsAdminGuard implements CanActivate {
  constructor(
    private userService: UserService,
    private router: Router
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    const authUser: User = this.userService.getCurrentUser()!;
    if (!authUser.canAccessAdminMenu()) {
      this.router.navigate(['/price-lists']);
    }

    return true;
  }
}
